
import { Component,Prop,Watch, BaseMixins } from '@/lib';

@Component
export default class Language extends BaseMixins {
    name:string='Language';
    @Prop({type:String,default:'zh-CN'}) lang:string;
    @Prop({type:Number,default:0}) messageUnreadCount:number;

    // get langList(){
    //     return abp.localization.languages.filter(val=>{
    //         return !val.isDisabled;
    //     });
    // }
    // changeLanguage(languageName:string){
    //     abp.utils.setCookieValue(
    //         "Abp.Localization.CultureName",
    //         languageName,
    //         new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
    //         abp.appPath
    //     );
    //     location.reload();
    // }
    // get currentLanguage(){
    //     return abp.localization.currentLanguage;
    // }

    langList:any = {
        'zh-CN': '语言',
        'zh-TW': '語言',
        'en-US': 'Lang'
    }
    localList:any = {
        'zh-CN': '中文简体',
        'zh-TW': '中文繁体',
        'en-US': 'English'
    }

    get currentLanguage(){
        return this.localization.languageList.find(item => item.name == this.localization.currentLanguageName);
    }

    get languages(){
      return this.localization.languageList.filter(val=>{
          return !val.isDisabled&&val.name!==this.localization.currentLanguageName;
      });
    }

    get localization(){
      return window.basic.localization;
    }

    get title () {
      //let lag = abp.localization.currentLanguage;
      let lag = this.lang;
      if(!lag){
        lag ='zh-CN';
      }
      return this.langList[lag];
    }

    selectLang (languageName) {
      this.$emit('on-lang-change', languageName);
    }

    @Watch('lang')
    langChange (lang) {
      //TODO: 语言切换
      //this.$i18n.locale = lang
    }
}
